import { render, staticRenderFns } from "./AddressComponent.vue?vue&type=template&id=1e2403b2"
import script from "./AddressComponent.vue?vue&type=script&lang=ts"
export * from "./AddressComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports